const formatSchemaReference = (schemaName: string): string => `#/components/schemas/${schemaName}`;

export default formatSchemaReference;
